import type { ICatalog } from '@platform/core/types';

/**
 * Каталог простору для оболонки за правилом прототипу v4 (stripRegistry): поза парламентом реєстри Ради (Верховна Рада, Комітети ВРУ)
 * лишаються модулями простору, лише якщо в цьому просторі є їхні записи; інакше — як невстановлені (у комітеті «Верховна Рада» — тільки
 * орієнтир меню «Рада»). У парламенті й без каталогу — без змін. Чиста функція.
 */
export function workspaceCatalog(catalog: ICatalog | undefined, parliament: boolean): ICatalog | undefined {
  if (!catalog || parliament) return catalog;
  const empty = (m: ICatalog['modules'][number]) => m.registry && m.recordTypes.every((r) => r.recordCount === 0);
  if (!catalog.modules.some((m) => m.installed && empty(m))) return catalog;
  return { ...catalog, modules: catalog.modules.map((m) => (m.installed && empty(m) ? { ...m, installed: false } : m)) };
}
